export function validateImportFile(file: File, maxSizeBytes: number): { valid: true } | { valid: false; errorKey: string } {
    const lastDotIndex = file.name.lastIndexOf('.');
    const extension = lastDotIndex === -1 ? '' : file.name.slice(lastDotIndex).toLowerCase();
    if (extension !== '.xlsx') {
        return { valid: false, errorKey: 'invalidImportFormat' };
    }
    if (file.size > maxSizeBytes) {
        return { valid: false, errorKey: 'importFileTooLarge' };
    }
    return { valid: true };
}
